<ng-container *ngIf="dataInsights$ | async as data">
    <div class="data_insight">
        <h3>Data Insights</h3>
        <p>Check out some insights from your responses!
            As a heads-up, this isn't a research study publication — it's a personalized
            report based on your Core Questionnaire answers and Registry data on
            {{data.cq_completed_date | date: 'MM/dd/yyyy' }}.</p>
    </div>    
    
    <div class="usage_data" >
       <div class="usage_data_items"> <app-cgm-usage-chart [dataInsight]="data.cgm_usage"></app-cgm-usage-chart></div>
       <div class="usage_data_items"> <app-glp-usage-chart [dataInsight]="data.glp_1_usage"></app-glp-usage-chart></div>
       <div class="usage_data_items"> <app-autoimmune-disease-chart [dataInsight]="data.autoimmune_diseases"></app-autoimmune-disease-chart></div>
       <div class="usage_data_items"> <app-duration-diabetes-chart [dataInsight]="data.duration_of_diabetes"></app-duration-diabetes-chart></div>
    </div>
    
    <app-age-diagnosis-chart [dataInsight]="data.age_of_diagnosis"></app-age-diagnosis-chart>
    <app-family-history-chart [dataInsight]="data.family_history"></app-family-history-chart>
    
    </ng-container>
    
    <router-outlet></router-outlet>